import React, { useState } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Iconify from './Iconify';
import { updateOrder } from '../services/redux-actions';
import { useDispatch } from 'react-redux';
import {
  updateAgreementAction,
  updateAgreementAnnexAction,
  updateOrderDocumentAction
} from '../services/request';
import { useParameterizedQuery } from 'react-fetching-library';
import toast from 'react-hot-toast';
import { formatDate } from '../services/functions';

const DateTimePickerIcon = ({
  order,
  tooltipTitle,
  value,
  fieldName,
  icon,
  disabled,
  type = null,
  annexId = null,
  formikFieldName = null
}) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { query } = useParameterizedQuery(updateAgreementAction);
  const { query: annexQuery } = useParameterizedQuery(
    updateAgreementAnnexAction
  );
  const { query: qualificationCardQuery } = useParameterizedQuery(
    updateOrderDocumentAction
  );

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onChange = async val => {
    if (type === 'agreement') {
      const { error, loading } = await query(order.agreement_id, {
        [fieldName]: val
      });
      if (!error && !loading) {
        dispatch(
          updateOrder({
            ...order,
            [formikFieldName ? formikFieldName : fieldName]: val
          })
        );
        toast.success('Zmieniono termin podpisania umowy');
      } else {
        toast.error('Nie udało się zmienić terminu podpisania umowy');
      }
    } else if (type === 'annex') {
      const { error, loading, payload } = await annexQuery(annexId, {
        [fieldName]: val
      });
      if (!error && !loading) {
        dispatch(
          updateOrder({
            ...order,
            order_annexes: order.order_annexes.map(annex => annex.id === annexId ? payload : annex)
          })
        );
        toast.success('Zmieniono termin podpisania aneksu');
      } else {
        toast.error('Nie udało się zmienić terminu podpisania aneksu');
      }
    } else if (type === 'qualification_card') {
      const qualificationCard = order.documents.filter(
        item => item.document_type === 'qualification_card'
      )[0];
      const { error, loading } = await qualificationCardQuery(
        qualificationCard.id,
        { [fieldName]: formatDate(val) }
      );
      if (!error && !loading) {
        dispatch(
          updateOrder({
            ...order,
            [formikFieldName ? formikFieldName : fieldName]: val
          })
        );
        toast.success(
          'Zmieniono termin końcowy na wypełnienie karty kwalifikacyjnej'
        );
      } else {
        toast.error(
          'Nie udało się zmienić terminu podpisania karty kwalifikacyjnej'
        );
      }
    }
  };

  return (
    <>
      <Tooltip title={tooltipTitle} placement="right-start">
        <IconButton edge="end" disabled={disabled} onClick={handleOpen}>
          <Iconify icon={icon} style={{ color: '#3366FF' }} />
        </IconButton>
      </Tooltip>

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          open={open}
          onClose={handleClose}
          value={value}
          onAccept={val => onChange(val)}
          onChange={val => {}}
          disableCloseOnSelect={true} // Utrzymuje okno otwarte do momentu wyboru godziny
          ampm={false}
          inputFormat="yyyy-MM-dd HH:mm"
          mask="____-__-__ __:__"
          renderInput={() => null}
        />
      </LocalizationProvider>
    </>
  );
};

export default DateTimePickerIcon;
